var manufacturers, models, diagrams, parts, modalWidth, mobile;

var searchLoader = `<div class="search-loading">
  					<div></div>
  					<div></div>
  					<div></div>
				</div>`;


if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    /* The full-width BROWSE PARTS bar this used to inject after the header is
       replaced by the compact .parts-search icon rendered in the header's
       action row (sections/header.liquid), which picks up the same click
       handler below. Keep the mobile flag: it sizes the picker modal. */
    mobile = true
}

//Activate parts search
$(".parts-search").on('click touch', function (e) {


    if (typeof searchable_brands !== 'undefined') {

        $("swal2-html-container").focus();

        manufacturers = searchLoader + `<div class="search-heading"><h2>TOP BRANDS</h2></div>`;

        e.preventDefault();
        searchable_brands.sort((a, b) => (a.name > b.name) ? 1 : -1)

        $.each(searchable_brands, function (index, brand) {

            var id = brand.id;
            var name = brand.name;
            var image = `https://parts.espressoparts.com/images/brands/${id}.jpg`;

            manufacturers = manufacturers + `<div data-id="${id}" class="col-search brand-search"><img src="${image}" alt="${name}"></div>`;
        });

        let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (mobile) {

            $('html, body').css({
                overflow: 'hidden',
                height: '100%'
            });

            modalWidth = screenWidth - 30;
        } else if (screenWidth > 1000) {

            modalWidth = 980;
        } else {

            modalWidth = screenWidth - 20;
        }


        Swal.fire({

            showConfirmButton: false,
            html: manufacturers,
            position: 'top',
            showClass: {
                backdrop: 'swal2-noanimation', // disable backdrop animation
                popup: '',                     // disable popup animation
                icon: ''                       // disable icon animation
            },
            hideClass: {
                popup: '',                     // disable popup fade-out animation
            },
            width: modalWidth,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCloseButton: true,
            didClose: () => {
                $(".swal2-html-container").html('');
                $('html, body').css({
                    overflow: 'auto',
                    height: 'auto'
                });
            }
        });
    }
});

//Get models by manufacturer id
$(document).on("click touch", ".brand-search", function () {

    showLoading();
    var id = $(this).data("id");
    models = `<div id="pManufacturers" class="previous-holder"><span class="previous ">&#8249;</span></div>${searchLoader}`;

    $.get(`https://parts.espressoparts.com/api/manufacturer/${id}`, function (response) {


        //If brand has models
        if (Object.keys(response.models).length) {

            models = models + `<div class="search-heading"><img src="https://parts.espressoparts.com/images/brands/${response.manufacturer_id}.jpg" alt="${response.manufacturer_name}"><h3>Models</h3></div>`;

            $.each(response.models, function (id, brand) {

                var image = `https://parts.espressoparts.com/images/models/${id}.jpg`;
                models = models + `<div data-id="${id}" class="col-search model-search"><img src="${image}" alt="${brand}"><p>${brand}</p></div>`;
            });
        } else {

            models = models + `<div class="search-heading"><img src="https://parts.espressoparts.com/images/brands/${response.manufacturer_id}.jpg" alt="${response.manufacturer_name}"><h3>Parts</h3></div>`;

            $.each(response.categories, function (id, category) {

                models = models + `<div data-manufacturer="${response.manufacturer_id}" data-category="${id}" class="col-search manufacturer-category-search"><span class="search-link">${category}</span></div>`;
            });
        }

        $(".swal2-html-container").html('').html(models);
    });

});

$(document).on("click", '#pManufacturers', function () {

    $(".swal2-html-container").html('').html(manufacturers);
});

//Get Diagrams by model id
$(document).on("click touch", ".model-search", function () {

    showLoading();
    var id = $(this).data("id");
    diagrams = `<div id="pModels" class="previous-holder"><span class="previous ">&#8249;</span></div>${searchLoader}`;

    $.get(`https://parts.espressoparts.com/api/model/${id}`, function (response) {

        let marginTop = 0;

        if (mobile) {

            marginTop = '60px';
        }

        diagrams = diagrams + `<div class="search-heading">
                                    <h2 style="margin-top:${marginTop}">${response.manufacturer.name} ${response.model.name}</h2>
                                    <img src="https://parts.espressoparts.com/images/models/${response.model.id}.jpg" alt="${response.model.name}">
                               </div>`;

        diagrams = diagrams + `<div class="search-row">`;

        if (Object.keys(response.diagrams).length) {

            if (!mobile) {
                diagrams = diagrams + `<div class="search-row"><div class="search-heading"><h3>Diagrams</h3></div>`;

                $.each(response.diagrams, function (id, diagram) {

                    var image = `https://parts.espressoparts.com/images/diagrams/${id}.jpg`;
                    diagrams = diagrams + `<div data-diagram="${diagram}" data-id="${id}" class="col-search diagram-search"><img src="${image}" alt="${diagram}"><p>${diagram}</p></div>`;
                });
            }
        }

        diagrams = diagrams + `</div><div class="search-row"><div class="search-heading"><h3>Part Categories</h3></div>
                               <div data-model="${response.model.id}" data-category="0" class="col-search model-category-search"><span class="search-link">ALL PARTS</span></div>
        `;

        $.each(response.categories, function (id, category) {

            diagrams = diagrams + `<div data-model="${response.model.id}" data-category="${id}" class="col-search model-category-search"><span class="search-link">${category}</span></div>`;
        });

        diagrams = diagrams + `</div>`;

        $(".swal2-html-container").html('').html(diagrams);
    });
});

$(document).on("click", '#pModels', function () {

    $(".swal2-html-container").html('').html(models);
});


//Get category parts by manufacturer id and category id
$(document).on("click touch", ".manufacturer-category-search", function () {

    showLoading();
    var manufacturer_id = $(this).data("manufacturer");
    var category_id = $(this).data("category");

    $.get(`https://parts.espressoparts.com/api/manufacturer/${manufacturer_id}/category/${category_id}`, function (response) {

        parts = `<div id="pManufacturers" class="previous-holder"><span class="previous ">&#8249;</span></div><div class="search-heading">
                                    <h2>${response.manufacturer}</h2>
                                    <h3>Category: ${response.category}</h3>
                               </div>`;


        $.each(response.parts, function (id, part) {

            if (part.shopify_product_id) {
                var url = `https://parts.espressoparts.com/shopify-id/${part.shopify_product_id}`;
                parts = parts + `<a target="_blank" href="${url}"><div class="parts-holder"><img onerror="imgError(this);" src="https://parts.espressoparts.com/images/parts/${part.id}.jpg" alt="${response.manufacturer}"><span class="search-link">${part.shopify_title} - (SKU: ${part.sku})</span></div></a>`;
            }
        });

        $(".swal2-html-container").html('').html(parts);
    });
})


//Get category parts by model id and category id
$(document).on("click touch", ".model-category-search", function () {

    showLoading();
    var model_id = $(this).data("model");
    var category_id = $(this).data("category");

    $.get(`https://parts.espressoparts.com/api/model/${model_id}/category/${category_id}`, function (response) {

        parts = `<div id="pDiagrams" class="previous-holder"><span class="previous ">&#8249;</span></div><div class="search-heading">
                                    <h2>${response.manufacturer} ${response.model}</h2>
                                    <img src="https://parts.espressoparts.com/images/models/${response.model_id}.jpg" alt="${response.model}">
                                    <h3>Category: ${response.category}</h3>
                               </div>`;


        $.each(response.parts, function (id, part) {

            if (part.shopify_product_id) {
                var url = `https://parts.espressoparts.com/shopify-id/${part.shopify_product_id}`;
                parts = parts + `<a target="_blank" href="${url}"><div class="parts-holder"><img onerror="imgError(this);" src="https://parts.espressoparts.com/images/parts/${part.id}.jpg" alt="${response.model}"><span class="search-link">${part.shopify_title} - (SKU: ${part.sku})</span></div></a>`;
            }
        });

        $(".swal2-html-container").html('').html(parts);
    });
})

$(document).on("click", '#pDiagrams', function () {

    $(".swal2-html-container").html('').html(diagrams);
});


//Open Diagram by diagram id
$(document).on("click touch", ".diagram-search", function () {

    showLoading();
    var diagramId = $(this).data("id");

    var html = `<div id="pParts" class="previous-holder"><span class="previous ">&#8249;</span></div><div class="web-annotation"><img id ="diagram" src="https://parts.espressoparts.com/images/diagrams/${diagramId}.jpg" alt="" style="width:100vw" class="diagram-border"></div>`;
    $(".swal2-html-container").html('').html(html);

    creatAnnotations(diagramId)

    $(document).on('click touch', '.a9s-annotation', function () {

        const shopifyId = $(this).data('shopify-id');

        if(shopifyId){
            var url = 'https://parts.espressoparts.com/shopify-id/' + $(this).data('shopify-id');
            window.open(url, '_blank').focus();
        } else {

            const partName = $(this).data('part_title');
            const diagramName = $(this).data('diagram_name');

            $(".swal2-html-container").html('').html(`
                                <form id="requestPart" method="post" style="margin:0 auto">
                                <div id="pDiagrams" class="previous-holder"><span class="previous ">&#8249;</span></div><div class="search-heading">
                                    <h2>Part Request Form</h2>
                                    <h3>${partName}</h3>
                                    
                                    <div style="width:410px;margin:0 auto">
                                        <div style="float: left; text-align: left;margin-right: 10px">
                                            <p><label style="text-align: left;line-height: 0">First Name</label><br><input name='first_name' type="text" class="swal2-input" style="width:200px;margin:5px 0" placeholder="First Name"></p>
                                        </div>
                                        <div style="float: left; text-align: left; margin-bottom: 10px">
                                            <p><label style="text-align: left;line-height: 0">Last Name</label><br><input name='last_name' type="text" class="swal2-input" style="width:200px;margin:5px 0" placeholder="Last Name"></p>
                                        </div>
                                    </div>
                                    
                                    <div style="clear: both;width:410px;margin:0 auto; text-align:left">
                                        <p><label style="text-align: left;line-height: 0">E-Mail Address</label><br><input name='customer_email' type="email" class="swal2-input" style="width:410px;margin:5px 0" placeholder="Email Address"></p>
                                        <p><label style="text-align: left;line-height: 0">Telephone Number (Optional)</label><br><input name='customer_tel' type="tel" class="swal2-input" style="width:410px;margin:5px 0" placeholder="Telephone Number"></p>
                                        <input type="hidden" name="part_name" value="${partName}">
                                        <input type="hidden" name="diagram_name" value="${diagramName}">
                                        <p style="font-weight:bold;color: darkred" id="formError"></p>
                                    </div>    
                                    <button id="formButton" style="background-color: #930" type="submit" class="swal2-confirm swal2-styled" aria-label="" style="display: inline-block;">Request Part</button>
                                    <br>
                                    <br>
                                    
                               </div>
                               </form>
                               `);


            $(document).on('submit', '#requestPart', function (e) {

                e.preventDefault();

                $('input').on('focus', function () {

                    $("#formError").html("");
                })

                $("#formError").html('');
                $("#formButton").hide();

                var values = $(this).serialize();

                $.post(`https://parts.espressoparts.com/api/request-part`,values, function (response) {

                    if(response.error){

                        $("#formError").html(response.error);
                        $("#formButton").show();
                    } else {

                        $(".swal2-html-container").html('').html(`
                                <div id="pDiagrams" class="previous-holder"><span class="previous ">&#8249;</span></div><div class="search-heading">
                                    <h2>Part Request Form</h2>
                                    <h3 style="font-size: 90%; color:red">Thank you, your parts request has been submitted. A customer representative will be in contact regarding pricing and an expected delivery date.</h3>
                               </div>
                               `);

                        $(".previous-holder").empty();
                    }
                });

            });

        }



    })
});

$(document).on("click", '#pParts', function () {

    $(".swal2-html-container").html('').html(diagrams);
});

function creatAnnotations(diagramId) {

    var anno = Annotorious.init({
        image: 'diagram',
        disableSelect: true,
        disableEditor: true,
    });

    anno.loadAnnotations(`https://parts.espressoparts.com/api/diagram/${diagramId}`).then(function (annotation) {

        //Add tooltip if Shopify ID
        $(".a9s-annotation").each(function () {
            var sid = $(this).data('id');
            var result = annotation.find(({id}) => id === sid);

            if (result.shopify_id) {

                var title = result.shopify_title ?? result.supplier_product_title;
                title = title + ` <br> CLICK TO VIEW`

                $(this).attr('data-shopify-id', result.shopify_id);
            } else {

                var title = result.part_title;
                title = title + ` <br> CLICK TO REQUEST PART`

                $(this).attr('data-shopify-id', 0);
                $(this).attr('data-part_title', result.part_title);
                $(this).attr('data-diagram_name', result.diagram_name);
            }

            $(this).attr('title', title).tooltip({
                content: function () {
                    return title;
                }
            });

        });
    });
}


function showLoading() {

    $('.col-search').remove();
    $('.search-heading').remove();
    $('.search-loading').css({'display': 'flex'});
}

function imgError(image) {
    image.onerror = "";
    image.src = "https://parts.espressoparts.com/images/parts/no-image.png";
    return true;
}
